module.exports = __webpack_public_path__ + "img/3dForm2.3003dc8d.svg";